
    <lottie-animation-view
      [options]="lottieConfig"
      [width]="100"
      [height]="100">
    </lottie-animation-view>
  


// WEBPACK FOOTER //
// ./node_modules/@bci/styleline/dist/components/bci-spinner/bci-spinner.component.d.ts.BciSpinnerComponent.html